
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';
import BottomNav from '../../../components/feature/BottomNav';

const FlightResultsPage: React.FC = () => {
  const navigate = useNavigate();
  const [sortBy, setSortBy] = useState('price');
  const [showFilters, setShowFilters] = useState(false);

  const flights = [
    {
      id: 1,
      airline: 'الخطوط السعودية',
      logo: 'https://public.readdy.ai/ai/img_res/0f73a9572e0f1bd54def3612c5f8eb7f.jpg',
      departure: {
        time: '08:30',
        airport: 'RUH',
        city: 'الرياض'
      },
      arrival: {
        time: '11:45',
        airport: 'DXB',
        city: 'دبي'
      },
      duration: '3س 15د',
      stops: 'مباشر',
      price: 1250,
      class: 'اقتصادية',
      baggage: '23 كيلو',
      wifi: true,
      meal: true
    },
    {
      id: 2,
      airline: 'طيران الإمارات',
      logo: 'https://readdy.ai/api/search-image?query=icon%2C%20Emirates%20Airlines%20logo%20design%2C%20professional%20airline%20branding%2C%20clean%20minimalist%20design%2C%20high%20quality%20details%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20corporate%20identity&width=60&height=60&seq=13&orientation=squarish',
      departure: {
        time: '14:20',
        airport: 'RUH',
        city: 'الرياض'
      },
      arrival: {
        time: '17:30',
        airport: 'DXB',
        city: 'دبي'
      },
      duration: '3س 10د',
      stops: 'مباشر',
      price: 1380,
      class: 'اقتصادية',
      baggage: '30 كيلو',
      wifi: true,
      meal: true
    },
    {
      id: 3,
      airline: 'فلاي أديل',
      logo: 'https://readdy.ai/api/search-image?query=icon%2C%20Flyadeal%20airline%20logo%20design%2C%20professional%20airline%20branding%2C%20clean%20minimalist%20design%2C%20high%20quality%20details%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20corporate%20identity&width=60&height=60&seq=14&orientation=squarish',
      departure: {
        time: '19:15',
        airport: 'RUH',
        city: 'الرياض'
      },
      arrival: {
        time: '22:25',
        airport: 'DXB',
        city: 'دبي'
      },
      duration: '3س 10د',
      stops: 'مباشر',
      price: 980,
      class: 'اقتصادية',
      baggage: '20 كيلو',
      wifi: false,
      meal: false
    },
    {
      id: 4,
      airline: 'ناس',
      logo: 'https://readdy.ai/api/search-image?query=icon%2C%20Flynas%20airline%20logo%20design%2C%20professional%20airline%20branding%2C%20clean%20minimalist%20design%2C%20high%20quality%20details%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20corporate%20identity&width=60&height=60&seq=15&orientation=squarish',
      departure: {
        time: '06:45',
        airport: 'RUH',
        city: 'الرياض'
      },
      arrival: {
        time: '09:55',
        airport: 'DXB',
        city: 'دبي'
      },
      duration: '3س 10د',
      stops: 'مباشر',
      price: 1100,
      class: 'اقتصادية',
      baggage: '20 كيلو',
      wifi: true,
      meal: false
    }
  ];

  const sortedFlights = [...flights].sort((a, b) => {
    if (sortBy === 'price') return a.price - b.price;
    if (sortBy === 'time') return a.departure.time.localeCompare(b.departure.time);
    if (sortBy === 'duration') return a.duration.localeCompare(b.duration);
    return 0;
  });

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <div className="fixed top-0 left-0 right-0 bg-white shadow-sm z-40 h-16">
        <div className="flex items-center justify-between h-full px-4">
          <button
            onClick={() => navigate('/flights')}
            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0"
          >
            <i className="ri-arrow-right-line text-gray-600"></i>
          </button>
          <div className="text-center flex-1 mx-4">
            <h1 className="text-lg font-bold text-gray-800 truncate">الرياض - دبي</h1>
            <p className="text-sm text-gray-600">الجمعة، 15 مارس</p>
          </div>
          <button 
            onClick={() => setShowFilters(!showFilters)}
            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0"
          >
            <i className="ri-filter-line text-gray-600"></i>
          </button>
        </div>
      </div>

      <div className="pt-20 px-4">
        {/* Sort Options */}
        <div className="bg-white rounded-xl p-4 mb-4 shadow-sm">
          <div className="flex space-x-2 space-x-reverse">
            <button
              onClick={() => setSortBy('price')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                sortBy === 'price'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-600'
              }`}
            >
              الأرخص
            </button>
            <button
              onClick={() => setSortBy('time')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                sortBy === 'time'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-600'
              }`}
            >
              الأسرع
            </button>
            <button
              onClick={() => setSortBy('duration')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                sortBy === 'duration'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-600'
              }`}
            >
              الأقصر
            </button>
          </div>
        </div>

        {/* Filters Panel */}
        {showFilters && (
          <div className="bg-white rounded-xl p-4 mb-4 shadow-sm">
            <h3 className="font-bold text-gray-800 mb-3">تصفية النتائج</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">نطاق السعر</label>
                <div className="flex items-center space-x-4 space-x-reverse">
                  <span className="text-sm text-gray-600">500 ريال</span>
                  <div className="flex-1 h-2 bg-gray-200 rounded-full">
                    <div className="h-2 bg-blue-600 rounded-full" style={{width: '60%'}}></div>
                  </div>
                  <span className="text-sm text-gray-600">2500 ريال</span>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <label className="flex items-center space-x-2 space-x-reverse">
                  <input type="checkbox" className="rounded" />
                  <span className="text-sm">واي فاي مجاني</span>
                </label>
                <label className="flex items-center space-x-2 space-x-reverse">
                  <input type="checkbox" className="rounded" />
                  <span className="text-sm">وجبات مجانية</span>
                </label>
              </div>
            </div>
          </div>
        )}

        {/* Results Summary */}
        <div className="bg-blue-50 rounded-xl p-4 mb-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-blue-800">تم العثور على {sortedFlights.length} رحلة</p>
              <p className="text-xs text-blue-600">أفضل الأسعار لهذا التاريخ</p>
            </div>
            <div className="text-left">
              <p className="text-lg font-bold text-blue-800">من {Math.min(...flights.map(f => f.price))} ريال</p>
            </div>
          </div>
        </div>

        {/* Flight Results */}
        <div className="space-y-4">
          {sortedFlights.map((flight) => (
            <div key={flight.id} className="bg-white rounded-xl p-4 shadow-sm">
              {/* Airline Header */}
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-3 space-x-reverse">
                  <div className="w-8 h-8 overflow-hidden rounded-full flex items-center justify-center">
                    <img
                      src={flight.logo}
                      alt={flight.airline}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="font-medium text-gray-800">{flight.airline}</span>
                </div>
                <span className="text-sm text-gray-600">{flight.class}</span>
              </div>

              {/* Flight Details */}
              <div className="flex items-center justify-between mb-4">
                <div className="text-center">
                  <div className="text-xl font-bold text-gray-800">{flight.departure.time}</div>
                  <div className="text-sm text-gray-600">{flight.departure.airport}</div>
                  <div className="text-xs text-gray-500">{flight.departure.city}</div>
                </div>

                <div className="flex-1 mx-4">
                  <div className="flex items-center justify-center">
                    <div className="flex-1 h-px bg-gray-300"></div>
                    <div className="mx-2 text-center">
                      <i className="ri-plane-line text-blue-600"></i>
                      <div className="text-xs text-gray-500 mt-1">{flight.duration}</div>
                      <div className="text-xs text-green-600">{flight.stops}</div>
                    </div>
                    <div className="flex-1 h-px bg-gray-300"></div>
                  </div>
                </div>

                <div className="text-center">
                  <div className="text-xl font-bold text-gray-800">{flight.arrival.time}</div>
                  <div className="text-sm text-gray-600">{flight.arrival.airport}</div>
                  <div className="text-xs text-gray-500">{flight.arrival.city}</div>
                </div>
              </div>

              {/* Flight Features */}
              <div className="flex items-center space-x-4 space-x-reverse mb-4 text-xs">
                <div className="flex items-center space-x-1 space-x-reverse">
                  <i className="ri-luggage-cart-line text-gray-500"></i>
                  <span className="text-gray-600">{flight.baggage}</span>
                </div>
                {flight.wifi && (
                  <div className="flex items-center space-x-1 space-x-reverse">
                    <i className="ri-wifi-line text-green-600"></i>
                    <span className="text-green-600">واي فاي</span>
                  </div>
                )}
                {flight.meal && (
                  <div className="flex items-center space-x-1 space-x-reverse">
                    <i className="ri-restaurant-line text-orange-600"></i>
                    <span className="text-orange-600">وجبة</span>
                  </div>
                )}
              </div>

              {/* Price and Book Button */}
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-2xl font-bold text-blue-600">{flight.price} ريال</div>
                  <div className="text-sm text-gray-500">شامل الضرائب</div>
                </div>
                <Button
                  onClick={() => navigate(`/flights/booking/${flight.id}`)}
                  size="sm"
                >
                  اختيار
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Load More */}
        <div className="text-center mt-6">
          <button className="text-blue-600 font-medium py-2 px-4 rounded-lg hover:bg-blue-50 transition-colors">
            عرض المزيد من النتائج
          </button>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default FlightResultsPage;
